module.exports = __webpack_public_path__ + "static/media/stormy.a9b8f062.mov";